import store from "@/store";
import _ from "lodash";
import { _api_carcloud } from "./axios";
import { authAssign } from "@/helper/Auth.js";
import { httpAxios } from "@/views/home/serve/header";

// 登陆
export function login(params) {
  const url = `/bt-account-authority-api/authority/v1.0/toB/login/loginWithCode`;
  return _api_carcloud.post(url, params);
}

// 获取短信验证码
export function getSmsCode(params) {
  const url = `/backend-api/v1.0/auth/getSmsCode`;
  return _api_carcloud.post(url, params);
}

// 获取用户信息
export async function queryLoginBaseInfoV2(params) {
  const url = `/backend-api/v1.0/auth/queryLoginBaseInfoV2`;
  return await _api_carcloud.get(url, { params }).then((res) => {
    res.data.data ? commitUserInfo(res.data.data, params.id) : null;
    return res.data || null;
  });
}

// 切换至登录统一入口
export async function switchSystemBack(params) {
  const url = `/bt-account-authority-api/authority/v1.0/toB/jump/getEncryptUrl`;
  await _api_carcloud.post(url, params).then((res) => {
    const result = res.data;
    if (result.code === "000000") {
      sessionStorage.clear();
      window.location.href = result.data;
    }
  });
}

// 获取用户所有角色
export function queryLoginRoleCurrentSystem(params) {
  const url = `/backend-api/v1.0/user-auth/login/queryLoginRoleCurrentSystem`;
  return _api_carcloud.post(url, params);
}

// 设置默认角色
export function setDefaultRole(params) {
  const url = `/backend-api/v1.0/user-auth/login/setDefaultRole`;
  return _api_carcloud.post(url, params);
}

// 获取路由权限
export function queryChildResourcesByUri(params) {
  const url = `/backend-api/v1.0/auth/resources/queryChildResourcesByUri`;
  return _api_carcloud.get(url, { params });
}

export function commitUserInfo(data, id) {
  // 原逻辑 存储用户username；
  if (!data) {
    return;
  }
  sessionStorage.setItem("userName", data.accountName);
  // 当前用户信息对象
  let userInfoObj = {};
  userInfoObj.loginTimes = new Date().getTime(); // 登录时间，切换角色会更新登录时间
  userInfoObj.enterpriseId = data.enterpriseId; // 用户企业ID
  userInfoObj.roles = data.authRoles; // 角色列表
  userInfoObj.roleId = data.roleId; // 当前角色ID
  userInfoObj.brandId = data.brandId; // 当前角色brandID
  userInfoObj.orgs = data.deptId; // 暂无用处
  userInfoObj.default = data.accountId === 1 ? false : true; // 原逻辑 暂无用处
  userInfoObj._id = data.accountId; // 原用户ID
  userInfoObj.accountId = data.accountId; // 适配现用ID用户；
  userInfoObj.username = data.accountName; //
  userInfoObj.accountName = data.accountName; //
  userInfoObj.name = data.name; // 原name 姓名
  userInfoObj.mobile = data.phone; // 原手机号
  userInfoObj.phone = data.phone; // 适配现用手机号
  userInfoObj.email = data.email; // email
  userInfoObj.jobNumber = data.staffNo; // 原工位号
  userInfoObj.staffNo = data.staffNo; // 适配现用工位号
  userInfoObj.deptName = data.deptName; // 适配现用当前组织机构id名称
  userInfoObj.deptId = data.deptId; // 适配现用当前组织机构id
  userInfoObj.sysSource = data.sysSource; // 适配现用
  userInfoObj.dealerCode = data.dealerCode; // 适配现用经销商code
  // 判断当前角色
  let roleObj = data.authRoles.find((item) => {
    return item.id === id;
  });
  let roleId;
  let brandId;
  let enterpriseId = data.enterpriseId;
  let authRoleObj = {};
  // 当前角色ID,当前角色brandId
  if (roleObj) {
    roleId = roleObj.id;
    brandId = roleObj.brandAuthCode;
    authRoleObj = roleObj;
  } else {
    roleId = data.authRoles[0].id;
    brandId = data.authRoles[0].brandAuthCode;
    authRoleObj = data.authRoles[0];
  }
  userInfoObj.roleId = roleId;
  userInfoObj.brandId = brandId;
  userInfoObj.authRoleObj = authRoleObj; // 用户当前角色对象取值
  sessionStorage.setItem("PRIVATE_USER_ROLEID", roleId);
  sessionStorage.setItem("VIEWS_KEY", JSON.stringify(userInfoObj.menus));
  store.commit("SET_USER_INFO", userInfoObj);
  authAssign(enterpriseId, brandId);
}

// 获取登陆信息
export async function checkBroser(params) {
  const url = `/bt-account-authority-api/authority/v1.0/toB/jump/getDecryptInfoInUrl`;
  return await _api_carcloud.post(url, params).then((res) => {
    return res.data || null;
  });
}

// 查询是否是统一登录平台进来的
export async function getStk() {
  let query = null;

  if (typeof location.search === "string") {
    let search = location.search
      .substring(1)
      .replace(/\//, "")
      .split("&");
    if (Array.isArray(search)) {
      search.forEach((item) => {
        const key = item.split("=");
        if (key[0] === "stk" && !query) {
          query = { stk: key[1] };
        }
      });
    }
  }
  if (_.isPlainObject(query) && query.stk) {
    const res = await checkBroser({ encryptStr: query.stk });

    const token = _.get(res, "data.token");
    const systemNum = _.get(res, "data.systemNum");
    sessionStorage.setItem("bt_isSingle", "true");
    if (res && token) {
      sessionStorage.setItem("dashboard-token", token);
      if (systemNum > 1) {
        sessionStorage.setItem("bt_systemList", "true");
      }
      location.href = location.origin;
    } else {
      httpAxios();
    }
  }
}

// 修改用户信息
export async function updatePlatUser(params) {
  const url = `/backend-api/v1.0/operation/user/updatePlatUser`;
  return await _api_carcloud.post(url, params);
}

// 修改密码
export async function changePassword(params) {
  const url = `/backend-api/operperm/v1.0/account/changePassword`;
  return await _api_carcloud.post(url, params);
}

// 切换角色
export async function setLastRole(params) {
  const url = `/backend-api/v1.0/user-auth/login/setLastRole`;
  return await _api_carcloud.post(url, params);
}

// 查询品牌
export async function getVehiclebrandName() {
  const url = `/eshowroom/v1.0/vehicle/brands`;
  return await _api_carcloud.get(url);
}

// 根据品牌code查询车型列表
export function getModelLists(params) {
  const url = `/eshowroom/v1.0/vehicle/b-models`;
  return _api_carcloud.get(url, { params });
}
